import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { HERO_IMAGE } from '../data/content';
export function Hero() {
  return <header className="relative w-full overflow-hidden bg-ink-950 px-4 pb-12 pt-8 sm:px-6 sm:pb-16 sm:pt-12" data-id="element-131" data-mp="9k0b6xwjpxkw">
      <div aria-hidden="true" className="pointer-events-none absolute left-1/2 top-0 h-[420px] w-[420px] -translate-x-1/2 rounded-full bg-lime/20 blur-[120px]" data-id="element-132" data-mp="4n1lqsntuet1" />
      <div className="relative mx-auto flex w-full max-w-3xl flex-col items-center text-center" data-id="element-133" data-mp="xa4ipgcuuhh6">
        <div className="mb-6 flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-4 py-1.5" data-id="element-134" data-mp="sai2qz5n6n4o">
          <ShieldCheckIcon className="h-4 w-4 text-lime" data-id="element-135" data-mp="nbexpepnwgwp" />
          <span className="text-[11px] font-bold uppercase tracking-[0.18em] text-white/80" data-id="element-136" data-mp="3d1a7phvug7c8">
            Anti-Refinement System™
          </span>
        </div>

        <motion.h1 initial={{
        opacity: 0,
        y: 18
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="font-display text-[30px] leading-[1.05] text-white sm:text-5xl" data-id="element-137" data-mp="3814aznapvuna">
          Reduce refinements and increase{' '}
          <span className="text-lime" data-id="element-138" data-mp="399jq3lb5st9t">predictability</span> in your aligner cases
        </motion.h1>

        <p className="mt-4 max-w-xl text-sm leading-relaxed text-white/70 sm:text-lg" data-id="element-139" data-mp="3e7uwtn65qnnt">
          The clinical system designed to help you identify planning errors before they become
          treatment problems — and finish more cases with fewer unnecessary refinements, less chair
          time and greater profitability.
        </p>

        <motion.img initial={{
        opacity: 0,
        scale: 0.94
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} src={HERO_IMAGE} alt="Anti-Refinement System clinical volumes shown on a book box and smartphone" className="my-7 w-full max-w-[420px] drop-shadow-[0_25px_60px_rgba(198,230,43,0.15)] sm:my-9 sm:max-w-[520px]" data-id="element-140" data-mp="2qi0o9hsvfl9d" />

        <div id="hero-cta" className="w-full max-w-md" data-id="element-141" data-mp="nbl2il2gggag">
          <CtaButton label="Get the Anti-Refinement System" sub="Instant download · One-time payment · Lifetime access · 7-day guarantee" data-id="element-142" data-mp="na08cwk1yzd4" />
        </div>
      </div>
    </header>;
}